import { useMemo } from 'react';

import { useFeatureAccountQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

import { FeatureAccountData } from './types';
import { useFeatureAccountPageComponents } from './use-feature-account-page-components';

export const useFeatureAccountPage = () => {
  const { featureAccountId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading: featureAccountPageComponentIdsLoading } = useFeatureAccountQuery({
    variables: { featureAccountId },
    skip: !useFeatureAccountPage,
  });

  const featureAccountData = data?.FeatureAccount;

  const {
    featureAccountPageComponents,
    featureAccountPageComponentsLoading,
  } = useFeatureAccountPageComponents(featureAccountData ?? undefined);

  const featureAccountPageWithPopulatedComponents: FeatureAccountData | null = useMemo(() => {
    if (!featureAccountData || !featureAccountPageComponents) {
      return null;
    }
    return { ...featureAccountData, components: featureAccountPageComponents };
  }, [featureAccountData, featureAccountPageComponents]);

  const featureAccountPageLoading =
    featureIdsLoading ||
    featureAccountPageComponentIdsLoading ||
    featureAccountPageComponentsLoading;

  return {
    featureAccountPageLoading,
    featureAccountPage: featureAccountPageWithPopulatedComponents,
    AccountPageId: featureAccountId,
  };
};
